import script from "./kalio-layout-avatar-dropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./kalio-layout-avatar-dropdown.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__